import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-left', 'ChevronLeft', [["path",{"d":"m15 6-6 6 6 6","key":"svg-0"}]]);